module.exports = __webpack_public_path__ + "static/media/BRONZE 90.81db2034.png";